<template>
  <div class="kc-maincontainer">
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="keylogincontainer">
      <div class="keyheading d-flex align-items-center">
        <h1>Sign in to your account</h1>
      </div>
      <div class="mainlog mb-5">
        <div class="keyname">
          <div class="topDiv mt-3">
            <label class="keylabel">Email &nbsp;</label>
            <b-form-input
              class="labelbox"
              id="input-1"
              placeholder="Enter here"
              autofocus
              type="text"
              v-model.trim="$v.username.$model"
              :class="{ error: $v.username.$error }"
              v-on:keyup.enter="onEnter"
            ></b-form-input>
            <div
              class="validationiconlogin"
              v-if="$v.username.$dirty && !$v.username.required"
              v-b-popover.hover.top.v-danger="{ content: 'Required' }"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>
            <div
              class="validationiconlogin"
              v-if="!$v.username.maxLength"
              v-b-popover.hover.top.v-danger="{
                content: `cannot enter more than 64 characters`,
              }"
              variant="primary"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>
            <div
              class="validationiconlogin"
              v-if="!$v.username.email"
              v-b-popover.hover.top.v-danger="{
                content: 'Email is invalid',
              }"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="keypassword">
          <div class="topDiv mt-3">
            <label class="keylabel">Password &nbsp;</label>
            <b-form-input
              class="labelbox"
              placeholder="Enter here"
              type="text"
              v-if="showPassword"
              v-model.trim="$v.password.$model"
              :class="{ error: $v.password.$error }"
              v-on:keyup.enter="onEnter"
            >
            </b-form-input>
            <b-form-input
              class="labelbox"
              placeholder="Enter here"
              type="password"
              v-else
              v-model.trim="$v.password.$model"
              :class="{ error: $v.password.$error }"
              v-on:keyup.enter="onEnter"
            >
            </b-form-input>
            <div
              class="validationdropdown"
              v-if="$v.password.$dirty && !$v.password.required"
              v-b-popover.hover.top.v-danger="{ content: 'Required' }"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>

            <div
              class="keyimage pointer"
              v-if="showPassword"
              @click="toggleShow"
            >
              <img src="../../assets/notviewicon.svg" alt="" />
            </div>
            <div
              class="keyimage pointer"
              v-if="!showPassword"
              @click="toggleShow"
            >
              <img src="../../assets/eyeicon.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div id="message"></div>
          <router-link to="/forgot">
            <div class="forgot">Forgot Password?</div>
          </router-link>
        </div>
      </div>

      <div class="text-center">
        <b-button @click="validateuser" class="addbtn pr-3 pl-3 mt-5"
          >SIGN IN</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import errorModal from "../../components/mixin/toast";
import { required, email, maxLength } from "vuelidate/lib/validators";
const qs = require("qs");
import { mapGetters, mapMutations } from "vuex";
import { removeToken } from "../../utils/tokenCheck";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

export default {
  name: "LoginPage",
  components: {
    Spinner,
  },
  mixins: [errorModal],
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      accesstoken: "",
      LoaderStatus: false,
      // refreshtoken: "",
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
    ...mapGetters("userVUEX", {
      roleName: "getRoleValues",
    }),
  },
  validations: {
    username: {
      required,
      email,
      maxLength: maxLength(64),
    },
    password: {
      required,
    },
  },
  methods: {
    onEnter() {
      this.validateuser();
    },
    ...mapMutations({
      setToken: "userVUEX/SET_TOKEN",
      setRefreshToken: "userVUEX/SET_REFRESH_TOKEN",
    }),
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    validateuser() {
      this.$v.$touch();
      this.LoaderStatus = true;
      if (!this.$v.$invalid) {
        let username = this.username.trim();
        let password = this.password;
        // Check if both 'uuid' and 'panel' parameters exist in the current route's query.
        const isPanel = this.$route.query.uuid && this.$route.query.panel;

        // Create a userDetails object.
        let userDetails = {
          // Use the 'qs' library to stringify keycloak parameters.
          keycloak: qs.stringify({
            grant_type: "password",
            // Use a ternary operator to determine the 'client_id' based on 'isPanel'.
            client_id: isPanel ? "panel-login" : "vue-test-app",
            username: username,
            password: password,
          }),
          // Set the 'username' property in userDetails to 'this.username'.
          username: this.username,
        };
        this.userLogin(userDetails, isPanel);
      } else {
        this.LoaderStatus = false;
        document.getElementById("message").innerHTML = "";
      }
    },
    userLogin(userDetails, isPanel) {
      this.$store
        .dispatch("userVUEX/Login", userDetails)
        .then((res) => {
          if (res.status == 200 && !isPanel) {
            this.$store
              .dispatch("userVUEX/getUserData", "login")
              .then((res) => {
                const { landingPage } = res;

                if (this.roleName.roleName == "Panelist") {
                  // Check if the user's role is "Panelist".
                  if (isPanel) {
                    // If it is, navigate to the "PanelDetails" route with the 'uuid' query parameter.
                    this.$router.push({
                      path: "/jobs/paneldetails/",
                      query: {
                        uuid: this.$route.query.uuid,
                      },
                    });
                  } else if (this.$route.query.redirect) {
                    this.$router.push({
                      path: this.$route.query.redirect,
                    });
                  } else {
                    // If the user is a "Panelist" but not on the panel, navigate to the landing page.
                    this.$router.push(landingPage);
                  }
                } else {
                  // If the user's role is not "Panelist", navigate to the landing page.
                  this.$router.push(landingPage);
                }

                if (res.status == 401) {
                  document.getElementById(
                    "message"
                  ).innerHTML = `${res.data.error_description}`;
                }
              })
              .catch((err) => {
                this.LoaderStatus = false;
                this.errorModal("You don't have access");
                this.setToken("");
                this.setRefreshToken("");
                removeToken();
                throw err;
              });
          } else if (isPanel) {
            this.$router.push({
              path: "/jobs/paneldetails/",
              query: {
                uuid: this.$route.query.uuid,
              },
            });
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.LoaderStatus = false;
            document.getElementById(
              "message"
            ).innerHTML = `${err.response.data.error_description}`;
          }
        });
    },
  },
};
</script>

<style>
#message {
  color: red;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  margin-top: 10px;
}
.validationdropdown {
  position: absolute;
  top: 5px;
  right: 30px;
}
.validationiconlogin {
  position: absolute;
  top: 5px;
  right: 12px;
}
.kc-maincontainer {
  height: 100vh;
  background: url("../../assets/keycloakbg.png") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: relative;
  display: flex;
  place-content: center;
  place-items: center;
}
.keylogincontainer {
  position: absolute;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  padding: 35px 95px;
}
.keyheading {
  font-weight: 600;
  font-size: 25px;
  line-height: 38px;
  /* identical to box height */
  color: #72738e;
}
.labelbox {
  border-radius: 3px !important;
  background: #fdfdfd;
  border: 0.7px solid rgba(114, 115, 142, 0.7);
  box-sizing: border-box;
  box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
  padding-left: 6px;
}
.keyname {
  margin-top: 74px;
}
.keypassword {
  margin-top: 45px;
}
.keylabel {
  background-color: var(--bg-inputfield);
  position: absolute;
  left: 0.5vw;
  top: -9px;
  font-weight: 500;
  font-size: 12px;
  /* identical to box height */
  color: #72738e;
  line-height: 18px;
  z-index: 5;
  padding-left: 6px;
  padding-right: 4px;
}
.forgot {
  position: absolute;
  margin-top: 10px;
  right: 94px;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height */
  color: #3f698e;
}

.newuser {
  margin-top: 30px;
  text-align: center;
  color: #72738e;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
}
.reg {
  margin-top: 30px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #3f698e;
}
.keyimage {
  position: absolute;
  top: 5px;
  right: 10px;
}
.keyimage img {
  width: 16px;
}
.mainlog .form-control:focus {
  box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25) !important;
}
</style>
